(function() {
    const header = document.querySelector('[data-header-overlay]');
    if (!header) {
      return;
    }

    const headerMode = header.dataset.headerMode || 'dynamic';
    const isStaticMode = headerMode === 'static';
    const headerOverlay = header.querySelector('.header__overlay');
    const isHome = (header.dataset.isHome || '').toLowerCase() === 'true';

    const THEME_WHITE = 'white';
    const THEME_DARK = 'dark';

    function hexToLuminance(hex) {
      if (!hex) return null;
      const sanitized = hex.trim().replace('#', '');
      if (sanitized.length !== 3 && sanitized.length !== 6) return null;
      const normalized = sanitized.length === 3
        ? sanitized.split('').map(char => char + char).join('')
        : sanitized;
      if (!/^[0-9a-fA-F]{6}$/.test(normalized)) return null;
      const r = parseInt(normalized.slice(0, 2), 16);
      const g = parseInt(normalized.slice(2, 4), 16);
      const b = parseInt(normalized.slice(4, 6), 16);
      const linearize = (value) => {
        const srgb = value / 255;
        return srgb <= 0.03928 ? srgb / 12.92 : Math.pow((srgb + 0.055) / 1.055, 2.4);
      };
      const lr = linearize(r);
      const lg = linearize(g);
      const lb = linearize(b);
      return 0.2126 * lr + 0.7152 * lg + 0.0722 * lb;
    }

    function getStaticTheme() {
      if (isStaticMode && isHome) {
        return THEME_DARK;
      }
      const backgroundHex = header.dataset.headerColor || '';
      const textHex = header.dataset.stickyText || '';
      const backgroundLuminance = hexToLuminance(backgroundHex);
      if (backgroundLuminance !== null) {
        return backgroundLuminance > 0.5 ? THEME_WHITE : THEME_DARK;
      }
      const textLuminance = hexToLuminance(textHex);
      if (textLuminance !== null) {
        return textLuminance > 0.5 ? THEME_DARK : THEME_WHITE;
      }
      return THEME_DARK;
    }

    function getStickyTheme() {
      const backgroundHex = header.dataset.stickyColor || '';
      const textHex = header.dataset.stickyText || '';
      const backgroundLuminance = hexToLuminance(backgroundHex);
      if (backgroundLuminance !== null) {
        return backgroundLuminance > 0.5 ? THEME_WHITE : THEME_DARK;
      }
      const textLuminance = hexToLuminance(textHex);
      if (textLuminance !== null) {
        return textLuminance > 0.5 ? THEME_DARK : THEME_WHITE;
      }
      const dataTheme = header.dataset.stickyTheme;
      if (dataTheme === THEME_WHITE || dataTheme === THEME_DARK) {
        return dataTheme;
      }
      return THEME_DARK;
    }

    const stickyTheme = getStickyTheme();
    const staticInitialTheme = header.dataset.staticTheme || '';

    function applyTheme(theme) {
      if (!theme) return;
      header.classList.remove('header--white-theme', 'header--dark-theme');
      header.classList.add(`header--${theme}-theme`);
    }

    let currentTheme = null;

    // Language selector functionality
    function initLanguageSelector() {
      const languageForms = document.querySelectorAll('[data-language-form]');
      if (!languageForms.length) return;

      languageForms.forEach(languageForm => {
        const languageButtons = languageForm.querySelectorAll('[data-language-option]');
        const languageToggle = languageForm.querySelector('[data-language-toggle]');
        const languageBody = languageForm.querySelector('[data-language-body]');

        if (languageToggle && languageBody) {
          languageToggle.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const isOpen =
              languageBody.classList.contains('language__body--open') ||
              languageBody.classList.contains('menu-drawer__language-options--open');
            const willOpen = !isOpen;

            if (languageBody.classList.contains('language__body')) {
              languageBody.classList.toggle('language__body--open', willOpen);
            }

            if (languageBody.classList.contains('menu-drawer__language-options')) {
              languageBody.classList.toggle('menu-drawer__language-options--open', willOpen);
            }

            if (languageToggle.classList.contains('language__top')) {
              languageToggle.classList.toggle('language__top--open', willOpen);
            }

            if (languageToggle.classList.contains('menu-drawer__language-toggle')) {
              languageToggle.classList.toggle('menu-drawer__language-toggle--open', willOpen);
            }

            if (languageToggle.hasAttribute('aria-expanded')) {
              languageToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
            }
          });

          document.addEventListener('click', (event) => {
            if (!languageForm.contains(event.target)) {
              if (languageBody.classList.contains('language__body')) {
                languageBody.classList.remove('language__body--open');
              }

              if (languageBody.classList.contains('menu-drawer__language-options')) {
                languageBody.classList.remove('menu-drawer__language-options--open');
              }

              if (languageToggle.classList.contains('language__top')) {
                languageToggle.classList.remove('language__top--open');
              }

              if (languageToggle.classList.contains('menu-drawer__language-toggle')) {
                languageToggle.classList.remove('menu-drawer__language-toggle--open');
              }

              if (languageToggle.hasAttribute('aria-expanded')) {
                languageToggle.setAttribute('aria-expanded', 'false');
              }
            }
          });
        }

        languageButtons.forEach(button => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            const locale = button.value;
            const input = languageForm.querySelector('input[name="locale_code"]');
            if (input) {
              input.value = locale;
              languageForm.submit();
            }
          });
        });
      });
    }

    // Check if any menu is open
    function isMenuOpen() {
      const cartDrawer = document.querySelector('cart-drawer');
      const cartDrawerOpen = cartDrawer && cartDrawer.classList.contains('active');
      
      return document.body.classList.contains('_menu-open') ||
             document.body.classList.contains('_sub-menu-open') ||
             document.body.classList.contains('_sub-menu-active-hover') ||
             document.body.classList.contains('_secondary-menu-open') ||
             document.documentElement.classList.contains('menu-open') ||
             document.documentElement.classList.contains('search-open') ||
             cartDrawerOpen;
    }

    function updateStaticFill() {
      if (!isStaticMode) return;
      // On non-home pages, always fill by default (sticky mode)
      const shouldFill = !isHome || window.scrollY > 0 || isMenuOpen();
      header.classList.toggle('header--static-filled', shouldFill);
      const targetTheme = shouldFill ? stickyTheme : (staticInitialTheme || stickyTheme || THEME_DARK);
      applyTheme(targetTheme);
    }

    // Get theme from section behind header
    function getSectionTheme() {
      if (!header) return stickyTheme;
      const sections = document.querySelectorAll('[data-header-theme]');
      const headerHeight = header.offsetHeight;

      for (const section of sections) {
        if (!section) continue;
        const rect = section.getBoundingClientRect();
        if (rect.top <= headerHeight / 2 && rect.bottom >= headerHeight / 2) {
          const themeAttr = section.getAttribute('data-header-theme');
          if (!themeAttr || themeAttr === 'default') {
            continue;
          }
          return themeAttr === 'dark' ? THEME_DARK : THEME_WHITE;
        }
      }
      return stickyTheme;
    }

    function shouldHoldHomeInitialTheme() {
      return isHome && window.scrollY === 0;
    }

    // Update header theme
    function updateTheme() {
      let newTheme;

      if (isStaticMode) {
        const staticTheme = getStaticTheme();
        applyTheme(staticTheme);
        if (headerOverlay) {
          headerOverlay.style.backgroundColor = '';
          headerOverlay.style.opacity = '';
        }
        updateStaticFill();
        currentTheme = staticTheme;
        return;
      }

      if (isMenuOpen()) {
        newTheme = THEME_DARK;
      } else if (shouldHoldHomeInitialTheme()) {
        newTheme = THEME_DARK;
      } else if (isHome) {
        newTheme = stickyTheme;
      } else {
        newTheme = getSectionTheme();
      }

      if (newTheme === currentTheme) return;

      currentTheme = newTheme;
      applyTheme(newTheme);
    }

    // Throttled scroll handler
    let scrollTimeout;
    function handleScroll() {
      if (isStaticMode) return;
      if (scrollTimeout) return;
      scrollTimeout = requestAnimationFrame(() => {
        if (!isMenuOpen()) updateTheme();
        scrollTimeout = null;
      });
    }

    // Watch for menu state changes
    const observer = new MutationObserver(() => {
      updateTheme();
      if (isStaticMode) updateStaticFill();
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    // Watch for cart drawer changes
    const cartDrawerElement = document.querySelector('cart-drawer');
    if (cartDrawerElement) {
      observer.observe(cartDrawerElement, { attributes: true, attributeFilter: ['class'] });
    }

    // Watch for submenu hover state changes (when _sub-menu-active is added/removed)
    document.querySelectorAll('.primary-nav__link').forEach(link => {
      const linkObserver = new MutationObserver(() => {
        // When _sub-menu-active is added, add class to body for CSS targeting
        if (link.classList.contains('_sub-menu-active')) {
          document.body.classList.add('_sub-menu-active-hover');
        } else {
          // Check if any other link has _sub-menu-active before removing
          const hasActiveSubmenu = document.querySelector('.primary-nav__link._sub-menu-active');
          if (!hasActiveSubmenu) {
            document.body.classList.remove('_sub-menu-active-hover');
          }
        }
        updateTheme();
      });
      linkObserver.observe(link, { attributes: true, attributeFilter: ['class'] });
    });

    // Initialize
    initLanguageSelector();
    updateTheme();
    if (isStaticMode) {
      updateStaticFill();
      window.addEventListener('scroll', updateStaticFill, { passive: true });
    } else {
      window.addEventListener('scroll', handleScroll, { passive: true });
    }

    function closePrimaryMenus() {
      document.querySelectorAll('.primary-nav__sub-menu .sub-menu__block').forEach(block => block.classList.remove('_sub-menu-open'));
      document.querySelectorAll('.primary-nav__link').forEach(link => link.classList.remove('_sub-menu-active'));
      document.body.classList.remove('_sub-menu-open');
      document.body.classList.remove('_sub-menu-active-hover');
    }

    // Primary navigation menu handlers
    document.querySelectorAll('.primary-nav__link').forEach(link => {
      link.addEventListener('click', (e) => {
        const parent = link.getAttribute('data-parent');
        const submenu = document.querySelector(`[data-submenu="${parent}"]`);
        if (!submenu) return;

        e.preventDefault();
        e.stopPropagation();
        const isOpen = submenu.classList.contains('_sub-menu-open');

        closePrimaryMenus();

        // Toggle if it was closed
        if (!isOpen) {
          document.body.classList.add('_sub-menu-open');
          submenu.classList.add('_sub-menu-open');
          link.classList.add('_sub-menu-active');
          
          // Calculate position for single-column menus
          if (submenu.classList.contains('_one-list')) {
            const subMenuContainer = document.querySelector('.sub-menu');
            if (subMenuContainer) {
              const subMenuRect = subMenuContainer.getBoundingClientRect();
              const triggerRect = link.getBoundingClientRect();
              const offsetX = triggerRect.left - subMenuRect.left;
              submenu.style.setProperty('--menu-item-left-pos', `${Math.max(0, offsetX)}px`);
            }
          }
        }
        if (isStaticMode) updateStaticFill();
      });
    });

    const secondaryNavLinks = Array.from(document.querySelectorAll('.secondary-nav__link--has-submenu'));
    const secondaryNavPanels = Array.from(document.querySelectorAll('[data-secondary-submenu]'));
    let secondaryMenuOpenId = null;

    function closeSecondaryMenus() {
      secondaryMenuOpenId = null;
      if (secondaryNavLinks.length) {
        secondaryNavLinks.forEach(link => link.classList.remove('secondary-nav__link--active'));
      }
      if (secondaryNavPanels.length) {
        secondaryNavPanels.forEach(panel => {
          panel.classList.remove('_sub-menu-open');
          panel.style.removeProperty('--secondary-offset');
          panel.style.removeProperty('--secondary-offset-x');
        });
      }
      document.body.classList.remove('_secondary-menu-open');
      if (!document.querySelector('.sub-menu__block._sub-menu-open')) {
        document.body.classList.remove('_sub-menu-open');
      }
      updateTheme();
      if (isStaticMode) updateStaticFill();
    }

    function openSecondaryMenu(id, triggerLink) {
      if (!id) return;

      closePrimaryMenus();

      secondaryMenuOpenId = id;
      document.body.classList.add('_secondary-menu-open');
      document.body.classList.add('_sub-menu-open');

      secondaryNavLinks.forEach(linkEl => {
        const isTarget = linkEl.dataset.secondaryParent === id;
        linkEl.classList.toggle('secondary-nav__link--active', isTarget);
      });

      let targetPanel = null;
      secondaryNavPanels.forEach(panel => {
        const isTarget = panel.dataset.secondarySubmenu === id;
        panel.classList.remove('_sub-menu-open');
        panel.style.removeProperty('--secondary-offset');
        panel.style.removeProperty('--secondary-offset-x');
        if (isTarget) {
          targetPanel = panel;
        }
      });

      if (targetPanel) {
        targetPanel.classList.add('_sub-menu-open');
        const subMenuContainer = document.querySelector('.sub-menu');
        if (subMenuContainer && triggerLink) {
          const subMenuRect = subMenuContainer.getBoundingClientRect();
          const triggerRect = triggerLink.getBoundingClientRect();
          const computedStyles = window.getComputedStyle(targetPanel);
          const paddingLeft = parseFloat(computedStyles.paddingLeft) || 0;
          const offsetX = triggerRect.left - subMenuRect.left - paddingLeft;
          targetPanel.style.setProperty('--secondary-offset-x', `${Math.max(0, offsetX)}px`);
        }
      }

      updateTheme();
      if (isStaticMode) updateStaticFill();
    }

    if (secondaryNavLinks.length) {
      secondaryNavLinks.forEach(link => {
        const id = link.dataset.secondaryParent;
        if (!id) return;

        const toggleMenu = (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (secondaryMenuOpenId === id) {
            closeSecondaryMenus();
          } else {
            openSecondaryMenu(id, link);
          }
        };

        link.addEventListener('click', toggleMenu);
        link.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            toggleMenu(event);
          }
        });
      });

      document.addEventListener('click', (event) => {
        const clickedSecondaryNav = event.target.closest('.secondary-nav');
        const clickedSecondaryPanel = event.target.closest('[data-secondary-submenu]');
        if (!clickedSecondaryNav && !clickedSecondaryPanel) {
          closeSecondaryMenus();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closePrimaryMenus();
          closeSecondaryMenus();
        }
      });
    }

    document.querySelectorAll('[data-close-submenu]').forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        closePrimaryMenus();
        closeSecondaryMenus();
        updateTheme();
        if (isStaticMode) updateStaticFill();
      });
    });

    // Mobile menu drawer handlers
    function initMobileDrawer() {
      const menuButton = document.querySelector('.header__monogram-icon');
      const menuDrawer = document.querySelector('.menu-drawer');
      const menuOverlay = document.querySelector('.menu-drawer__overlay');
      const menuToggleButtons = document.querySelectorAll('.menu-drawer__link[data-has-submenu="true"]');
      const submenuBlocks = document.querySelectorAll('.menu-drawer__submenu-block');
      const spollerButtons = document.querySelectorAll('[data-spoller], [data-spoller=""]');

      // Safety check - if no mobile drawer elements found, exit early
      if (!menuDrawer) {
        return;
      }

      // Open/close drawer
      if (menuButton && menuDrawer) {
        menuButton.addEventListener('click', () => {
          if (document.documentElement.classList.contains('search-open')) {
            document.documentElement.classList.remove('search-open');
          }
          closeSecondaryMenus();
          const willOpen = !menuDrawer.classList.contains('menu-drawer--open');
          menuDrawer.classList.toggle('menu-drawer--open');
          document.body.classList.toggle('_menu-open');
          if (isStaticMode) updateStaticFill();
          
          if (willOpen) {
            const headerContainer = document.querySelector('.header__container');
            if (headerContainer) {
              menuDrawer.style.setProperty('--header-offset', `${headerContainer.offsetHeight}px`);
            }
            // Re-initialize spoller buttons when drawer opens
            setTimeout(() => {
              const newSpollerButtons = document.querySelectorAll('[data-spoller], [data-spoller=""]');
              initializeSpollers(newSpollerButtons);
            }, 100);
          } else {
            resetMobileSubmenus();
          }
        });
      }

      function resetMobileSubmenus() {
        submenuBlocks.forEach(block => {
          if (!block) return;
          block.classList.remove('menu-drawer__submenu-block--active');
        });
        menuToggleButtons.forEach(linkEl => {
          linkEl.classList.remove('menu-drawer__link--open');
          linkEl.setAttribute('aria-expanded', 'false');
        });

        const mobileLanguageForm = document.getElementById('mobile-language-form');
        if (mobileLanguageForm) {
          const languageToggle = mobileLanguageForm.querySelector('[data-language-toggle]');
          const languageBody = mobileLanguageForm.querySelector('[data-language-body]');

          if (languageBody && languageBody.classList.contains('menu-drawer__language-options')) {
            languageBody.classList.remove('menu-drawer__language-options--open');
          }

          if (languageToggle) {
            languageToggle.classList.remove('menu-drawer__language-toggle--open');
            if (languageToggle.classList.contains('language__top')) {
              languageToggle.classList.remove('language__top--open');
            }
            if (languageToggle.hasAttribute('aria-expanded')) {
              languageToggle.setAttribute('aria-expanded', 'false');
            }
          }
        }
      }

      // Close drawer
      function closeDrawer() {
        if (!menuDrawer) return;
        menuDrawer.classList.remove('menu-drawer--open');
        document.body.classList.remove('_menu-open');
        resetMobileSubmenus();
      }

      if (menuOverlay) {
        menuOverlay.addEventListener('click', closeDrawer);
      }

      // Primary menu link handlers
      menuToggleButtons.forEach(link => {
        if (!link) return;
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const parentItem = link.closest('.menu-drawer__item');
          const submenu = parentItem ? parentItem.querySelector('.menu-drawer__submenu-block') : null;
          if (!submenu) return;

          const isOpen = submenu.classList.contains('menu-drawer__submenu-block--active');

          if (isOpen) {
            submenu.classList.remove('menu-drawer__submenu-block--active');
            link.classList.remove('menu-drawer__link--open');
            link.setAttribute('aria-expanded', 'false');
            return;
          }

          submenuBlocks.forEach(block => {
            if (!block) return;
            block.classList.remove('menu-drawer__submenu-block--active');
          });
          menuToggleButtons.forEach(otherLink => {
            otherLink.classList.remove('menu-drawer__link--open');
            otherLink.setAttribute('aria-expanded', 'false');
          });

          submenu.classList.add('menu-drawer__submenu-block--active');
          link.classList.add('menu-drawer__link--open');
          link.setAttribute('aria-expanded', 'true');
        });
      });

      // Initialize spoller functionality
      function initializeSpollers(buttons) {
        buttons.forEach(button => {
          // Remove existing listeners to prevent duplicates
          button.removeEventListener('click', handleSpollerClick);
          button.addEventListener('click', handleSpollerClick);
        });
      }

      function handleSpollerClick(e) {
        e.preventDefault();
        e.stopPropagation();
        const isOpen = this.classList.contains('menu-drawer__submenu-section-title--open');
        
        // Close all other spollers in the same submenu
        const submenuBlock = this.closest('.menu-drawer__submenu-block');
        if (submenuBlock) {
          submenuBlock.querySelectorAll('.menu-drawer__submenu-section-title').forEach(btn => {
            btn.classList.remove('menu-drawer__submenu-section-title--open');
          });
        }
        
        // Toggle current spoller
        if (!isOpen) {
          this.classList.add('menu-drawer__submenu-section-title--open');
        }
      }

      // Initialize spollers initially
      initializeSpollers(spollerButtons);
    }

    // Initialize mobile drawer
    initMobileDrawer();

    // Compatibility fixes for external app.js
    function addCompatibilityFixes() {
      // Wait for app.js to load and then override problematic functions
      setTimeout(() => {
        // Override the menuInit function to prevent errors with old selectors
        if (window.menuInit) {
          const originalMenuInit = window.menuInit;
          window.menuInit = function() {
            // Check if our new mobile drawer exists
            if (document.querySelector('.menu-drawer')) {
              return; // Skip the old menu initialization
            }
            // Fallback to original if old structure exists
            return originalMenuInit();
          };
        }

        // Add event listener to prevent errors from app.js click handlers
        document.addEventListener('click', (e) => {
          // Prevent app.js from trying to click on non-existent elements
          if (e.target.closest('.icon-menu')) {
            const oldMenuLink = document.querySelector('.menu-header__link');
            if (!oldMenuLink && document.querySelector('.menu-drawer')) {
              // If old menu structure doesn't exist but new one does, prevent app.js errors
              e.stopImmediatePropagation();
            }
          }
        }, true); // Use capture phase to run before app.js handlers
      }, 100);
    }

    // Apply compatibility fixes
    addCompatibilityFixes();

    // Create mock elements to prevent app.js errors
    function createMockElements() {
      // Create a mock menu-header__link element if it doesn't exist
      if (!document.querySelector('.menu-header__link') && document.querySelector('.menu-drawer')) {
        const mockElement = document.createElement('div');
        mockElement.className = 'menu-header__link';
        mockElement.style.display = 'none';
        mockElement.style.position = 'absolute';
        mockElement.style.left = '-9999px';
        document.body.appendChild(mockElement);
        
        // Add click method to prevent errors
        mockElement.click = function() {
        };
      }
    }

    // Create mock elements after DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', createMockElements);
    } else {
      createMockElements();
    }

    // Close submenu when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.primary-nav') && !e.target.closest('.sub-menu')) {
        closePrimaryMenus();
        closeSecondaryMenus();
        if (isStaticMode) updateStaticFill();
      }
    });

    // Reset menu state when page is restored from bfcache (browser back/forward)
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      // Close mobile menu drawer
      const menuDrawer = document.querySelector('.menu-drawer');
      if (menuDrawer) menuDrawer.classList.remove('menu-drawer--open');
      // Reset all menu-related body classes
      document.body.classList.remove('_menu-open', '_sub-menu-open', '_secondary-menu-open', '_sub-menu-active-hover');
      // Reset icon-menu (app.js) state
      document.documentElement.classList.remove('menu-open');
      // Reset filter/search overlays
      document.documentElement.classList.remove('filter-open', 'search-open');
      // Reset body lock from app.js
      document.documentElement.classList.remove('lock');
      document.body.style.paddingRight = '';
      document.querySelectorAll('[data-lp]').forEach(el => { el.style.paddingRight = ''; });
      // Reset submenu blocks and links
      closePrimaryMenus();
      document.querySelectorAll('.menu-drawer__submenu-block').forEach(b => b.classList.remove('menu-drawer__submenu-block--active'));
      document.querySelectorAll('.menu-drawer__link--open').forEach(l => l.classList.remove('menu-drawer__link--open'));
      document.querySelectorAll('.secondary-nav__link--has-submenu').forEach(l => l.classList.remove('secondary-nav__link--active'));
      document.querySelectorAll('[data-secondary-submenu]').forEach(p => {
        p.classList.remove('_sub-menu-open');
        p.style.removeProperty('--secondary-offset');
        p.style.removeProperty('--secondary-offset-x');
      });
      if (isStaticMode) updateStaticFill();
    });
  })();
